import { IStore } from '../../store';
import bfl1Actions, { TBFL1Actions } from './actions';
import bfl1Utils from './utils';
import { historyActions } from '../../_core/history';
import { rootRoutes } from '../../../routes';
import bfl1Selectors from './selectors';
import { IAuthActions } from '../auth/actions';
import { commonUtils } from '../../_common';
import bfl1HistoryMiddleware from './middlewares/history.middleware';
import createMiddleware from '../../_core/create-middleware';
import { marpolSelectors, marpolUtils } from '../marpol';

const bfl1BaseMiddleware = createMiddleware<
    IStore,
    TBFL1Actions | IAuthActions
>()
    .getMiddleware();

const bfl1Middlewares = [
    bfl1BaseMiddleware,
    bfl1HistoryMiddleware,
];

export default bfl1Middlewares;
